module.exports = __webpack_public_path__ + "img/auto-illustraition.7eb9ddb8.png";